var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clients-limit"},[_c('el-badge',{staticClass:"clients-limit__process",attrs:{"value":_vm.inProcess}},[_c('span',{staticClass:"clients-limit__fixed"},[_vm._v(" "+_vm._s(_vm.fixed)+" ")])]),_c('span',{staticClass:"clients-limit__limit"},[_vm._v(" / "+_vm._s(_vm.limit)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }